import { ApiRecord, field, rec } from '../../../models/api-response.model';

function pickBookingUnitCategoryValue(...values: string[]): string {
  for (const value of values) {
    const normalized = value.trim();
    if (normalized) {
      return normalized;
    }
  }
  return '';
}

/**
 * Resolves unit category for booking overview (Commercial, Residential, etc.).
 * Prefer unit / quotation / pricing fields over tower type (mixed-use towers).
 */
export function resolveBookingUnitCategoryFromApi(
  booking: ApiRecord,
  fallback = '',
): string {
  const summary = rec(booking['summary']);
  const core = rec(booking['core']);
  const pricing = rec(core['pricingSnapshot'] ?? core['pricing_snapshot']);
  const unit = rec(booking['unit']);
  const tower = rec(booking['tower']);
  const quotation = rec(booking['quotation']);
  const quotPricing = rec(
    quotation['pricingSnapshot'] ?? quotation['pricing_snapshot'],
  );
  const unitRef = rec(
    quotPricing['unit_reference'] ?? quotPricing['unitReference'],
  );

  return pickBookingUnitCategoryValue(
    field(summary, 'unitCategory'),
    field(summary, 'unit_category'),
    field(core, 'unitCategory'),
    field(core, 'unit_category'),
    field(unit, 'propertyType'),
    field(unit, 'property_type'),
    field(pricing, 'propertyType'),
    field(pricing, 'property_type'),
    field(unitRef, 'propertyType'),
    field(unitRef, 'property_type'),
    fallback,
    field(tower, 'towerType'),
    field(tower, 'tower_type'),
  );
}
